import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { AiOutlineLink, AiOutlineCalendar, AiOutlineEnvironment, AiOutlineUser } from "react-icons/ai";

import { MissionIcon } from "@/assets/Icons";
import api from "@/services/api";
import CommentForm from "../../components/CommentForm";
import CommentList from "../../components/CommentList";

const MissionCard = () => {
  const { id } = useParams();
  const [mission, setMission] = useState();
  const [loading, setLoading] = useState(true);
  const [refreshComments, setRefreshComments] = useState(false);

  const user = useSelector((state) => state.Auth.user);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/mission_ao/${id}`);
        setMission(data);
      } catch (e) {
        setLoading(false);
        toast.error(e.message);
      }
      setLoading(false);
    })();
  }, [id]);

  if (loading) return <div className="flex justify-center items-center h-64">Chargement...</div>;

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="flex flex-col w-full h-full">
        {/* Header */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 flex-shrink-0">
              <MissionIcon />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h1 className="text-xl font-bold text-gray-900">{mission.name || mission.offer_name}</h1>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                {(mission.sectors || []).map((sector) => (
                  <span key={sector} className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs">
                    {sector}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
          {mission.acheteur && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center gap-2 text-gray-700">
                <AiOutlineUser className="text-blue-500" />
                <span className="font-medium">Acheteur:</span>
              </div>
              <div className="mt-1 text-gray-900">{mission.acheteur}</div>
            </div>
          )}

          {mission.closure_date && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center gap-2 text-gray-700">
                <AiOutlineCalendar className="text-blue-500" />
                <span className="font-medium">Date de clôture:</span>
              </div>
              <div className="mt-1 text-gray-900">{new Date(mission.closure_date).toLocaleString()}</div>
            </div>
          )}

          {mission.localisation && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center gap-2 text-gray-700">
                <AiOutlineEnvironment className="text-blue-500" />
                <span className="font-medium">Localisation:</span>
              </div>
              <div className="mt-1 text-gray-900">{mission.localisation}</div>
            </div>
          )}

          {mission.url && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center gap-2 text-gray-700">
                <AiOutlineLink className="text-blue-500" />
                <span className="font-medium">Lien:</span>
              </div>
              <div className="mt-1">
                <a href={mission.url} target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1">
                  <span>Ouvrir l'offre</span>
                  <AiOutlineLink />
                </a>
              </div>
            </div>
          )}
        </div>

        {/* Description */}
        <div className="p-6 border-t border-gray-100">
          <h2 className="text-lg font-semibold mb-4">Description</h2>
          <div className="bg-gray-50 p-4 rounded-lg whitespace-pre-line">{mission.description ? mission.description : "Pas de description pour le moment..."}</div>
        </div>

        {/* Creation date */}
        {mission.created_at && (
          <div className="px-6 py-3 text-sm text-gray-500 border-t border-gray-100">
            Date de création: {new Date(mission.created_at).toLocaleString()}
            {mission.origin && <span className="ml-4">Source: {mission.origin}</span>}
          </div>
        )}

        {/* Comments */}
        <div className="p-6 border-t border-gray-100">
          <h2 className="text-lg font-semibold mb-4">Commentaires</h2>
          <CommentList setRefreshComments={setRefreshComments} refreshComments={refreshComments} id={id} />
          <div className="mt-4">
            <CommentForm setRefreshComments={setRefreshComments} id={id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionCard;
